import { ICardSMIReview } from '../CardSMIReview/interfaces';

export const SMIList: ICardSMIReview[] = [
  {
    logo: require(`./img/ymap.svg`).default,
    name: 'Яндекс Карты',
    city: '',
    rating: '4,6',
    link: 'https://yandex.ru/maps/org/dalli/53144684971/reviews/?ll=37.749868%2C55.761452&z=17',
  },
  {
    logo: require(`./img/hh.svg`).default,
    name: 'hh.ru',
    city: '',
    rating: '4,5',
    link: 'https://spb.hh.ru/employer/1356767',
  },
  {
    logo: require(`./img/2gis.svg`).default,
    name: '',
    city: 'Москва',
    rating: '4,8',
    link: 'https://2gis.ru/moscow/firm/70000001007506475',
  },
  {
    logo: require(`./img/2gis.svg`).default,
    name: '',
    city: 'Санкт-Петербург',
    rating: '4,8',
    link: 'https://2gis.ru/spb/firm/70000001033377019',
  },
  {
    logo: require(`./img/yell.svg`).default,
    name: 'Yell',
    city: 'Санкт-Петербург',
    rating: '4,9',
    link: 'https://www.yell.ru/spb/com/sluzhba-dostavki-dalli-servis-na-ligovskom-prospekte_12120542/reviews/',
  },
];
